import {
    FETCH_CUSWJWS,
    FETCH_CUSWJWMAKE
} from '../actions/customization';


export const initialState = {
    isFetching: true,
    data: null
};

export const cusWjws = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_CUSWJWS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_CUSWJWS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}
export const cusWjwMake = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_CUSWJWMAKE}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_CUSWJWMAKE}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/redux/reducers/customization.js